import "core-js/modules/es.array.push.js";
import CreditsIcon from "@/components/common/creditsIcon.vue";
import { useStore } from "vuex";
import { ref, computed, onBeforeUpdate, reactive, onMounted, nextTick, onUpdated } from 'vue';
import { useActions } from '@/utils/map-state';
import { promoteUrl } from "@/utils/url";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "ThreadBlockPC",
  components: {
    CreditsIcon
  },
  props: {
    threads: {
      types: Array,
      default: []
    },
    fid: {},
    disableOrderTop: {
      type: Boolean,
      default: false
    },
    highlightKeyword: {
      type: String,
      default: ''
    }
  },
  setup(props, {
    emit
  }) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const adminActions = useActions('admin', ['updateThreadSelectedStatus']);
    // 勋章对应等级
    let medalsNum = function medalsNum(num) {
      return num > 10 ? 59 : num;
    };
    let gotoPage = (url, target = false) => {
      if (target) {
        window.open(promoteUrl() + '/' + url);
      } else {
        window.location = promoteUrl() + '/' + url;
      }
    };
    let gotoUserPage = (uid, target = false) => {
      let url = '/user/' + uid + '/thread';
      if (target) {
        const routeData = router.resolve(url);
        window.open(promoteUrl() + '/n/' + routeData.href);
      } else {
        router.push(url);
      }
    };
    const isAdmin = computed(() => store.state.user.isAdmin);
    const state = reactive({
      showChkbox: computed(() => {
        return props.fid > 0 && props.fid !== 41 && isAdmin.value;
      })
    });
    const checkboxRefs = ref([]);
    const toggle = index => {
      adminActions.updateThreadSelectedStatus({
        'tid': index
      });
      checkboxRefs.value[index].toggle();
    };
    let test = ref(true);
    let showTopicBlock = length => {
      return !(length < 1 || route.name === 'topic' && length < 2);
    };
    onMounted(() => {
      //侦测 话题overflow
      nextTick(() => {
        document.querySelectorAll('.thread-block-pc .topic').forEach(item => {
          if (item.offsetWidth < item.scrollWidth) {
            item.classList.add('topic-ellipsis');
          }
        });
      });
    });
    onUpdated(() => {
      nextTick(() => {
        document.querySelectorAll('.thread-block-pc .topic').forEach(item => {
          if (item.offsetWidth < item.scrollWidth) {
            item.classList.add('topic-ellipsis');
          }
        });
      });
    });
    onBeforeUpdate(() => {
      checkboxRefs.value = [];
    });
    return {
      versionControl: computed(() => store.state.versionControl),
      isAdmin,
      test,
      props,
      showTopicBlock,
      medalsNum,
      gotoPage,
      gotoUserPage,
      state,
      checkboxRefs,
      toggle
    };
  }
};